import React, { Component } from "react";
import { Typography, Box, Grid, Chip } from "@material-ui/core";
import clsx from "clsx";
import { formErrorState, formState, FormStore } from "../../../store/form.store";
import { currentUserState } from "../../../../services/session.manager";
import { ROLES } from "../../../../services/form.helper.service";
import { FORM_STATUS } from "../../../utilities/Constants";
import { withStyles } from "@material-ui/styles";
import Components from "../../form-element/CompMap";
import FormErrorView from "./FormErrorView";
import { toSetDefaultEditorBreakTag } from "../../../../utility/CommonUtils";
import QuestionCommentsPanel from "./QuestionCommentsPanel";

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  sectionBody: {
    borderTop: "1px solid rgba(0, 0, 0, .08)",
    "&:hover": {
      backgroundColor: "#FCFCFC",
    },
  },
  activeQ: {
    backgroundColor: "rgba(91, 195, 115, .1)",
    border: "1px solid rgb(91, 195, 115)",
    "&:hover": {
      backgroundColor: "rgba(91, 195, 115, .1)",
    },
  },
  questionText: {
    color: "#00000094",
    "& ul": {
      listStyleType: "disc",
      paddingLeft: theme.spacing(3),
      marginTop: theme.spacing(1),
    },
    "& ol": {
      listStyleType: "decimal",
      paddingLeft: theme.spacing(3),
      marginTop: theme.spacing(1),
    },
    "& li": {
      marginTop: theme.spacing(0.5),
    },
  },
});

export class FormQuestions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      element: props.element,
      errors: [],
      currentUser: {},
    };
  }

  componentDidMount() {
    this.userSubscription = currentUserState.subscribe((user) => {
      this.setState({ currentUser: user || {} });
    });

    if (this.props.element !== undefined) {
      this.formErrorObservable = formErrorState.subscribe((response) => {
        if (response) {
          if (response[this.props.element.id || this.props.element.elementId]) {
            this.setState({
              errors:
                response[this.props.element.id || this.props.element.elementId],
            });
            return;
          }
          this.setState({ errors: [] });
        }
      });
    }
  }

  componentWillUnmount() {
    this.userSubscription?.unsubscribe();
    this.formErrorObservable?.unsubscribe();
  }

  onChange(answer, element) {
    const formStore = FormStore.sharedInstance?.();
    formStore?.recordAnswer?.(answer, element);
  }

  render() {
    const { classes } = this.props;
    const { currentUser } = this.state;
    const formStatus = formState.getValue()?.formStatus || "";
    const canAddComments =
      currentUser?.userRole !== ROLES.TECHNICIAN &&
      (formStatus === FORM_STATUS.COMPLETED ||
        formStatus === FORM_STATUS.INPROGRESS);
    const store = FormStore.sharedInstance();
    const element = this.props.element;
    return (
      <div>
        {this.props.element &&
        this.props.element?.componentType !== "helpimage" &&
        this.props.element?.properties?.visible ? (
          <Box
            onClick={this.onClickQuestion}
            className={clsx(classes.sectionBody, {
              [classes.activeQ]: this.state.active,
            })}
          >
            <Box p={3}>
              <Grid container>
                <Grid item md={6} xs={6}>
                  <Chip
                    color="primary"
                    style={{ backgroundColor: "#bdbdbd" }}
                    key="question"
                    label={`Q${this.props.elementIndex + 1}.`}
                    size="small"
                  />
                  <Typography className={classes.questionText} component="div">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: toSetDefaultEditorBreakTag(
                          this.props.element.label,
                        ),
                      }}
                    ></div>
                  </Typography>
                </Grid>
                <Grid item md={6} xs={6}>
                  <RenderElement
                    onChange={this.onChange}
                    errors={this.state.errors}
                    element={this.props.element}
                    updateGeIdTagProperty={this.props.updateGeIdTagProperty}
                    formDataId={this.props.formDataId}
                  />
                  <QuestionCommentsPanel
                    element={this.props.element}
                    canAddComments={canAddComments}
                    onAdd={(commentText) => store.upsertQuestionComment(element, commentText, currentUser)}
                    onEdit={(index, text) => store.editQuestionComment(element, index, text, currentUser)}
                    onDelete={(index) => store.deleteQuestionComment(element, index)}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>
        ) : (
          ""
        )}
      </div>
    );
  }
}

const RenderElement = (props) => {
  if (!props.element || !props.element.componentType) {
    return <div>Invalid component type</div>;
  }

  const Element = Components[props.element.componentType];

  return (
    <>
      <Element
        element={props.element}
        hasError={props.errors && props.errors.length > 0}
        onChange={props.onChange}
        updateGeIdTagProperty={props.updateGeIdTagProperty}
        formDataId={props.formDataId}
      />
      {props.errors && props.errors.length > 0 ? (
        <RenderError errors={props.errors} />
      ) : null}
    </>
  );
};

const RenderError = (props) => {
  return props.errors.map((error) => {
    return <FormErrorView errorMessage={error} />;
  });
};

export default withStyles(styles)(FormQuestions);
